"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _dvaNoRouter = require("dva-no-router");

require("./index.less");

var _modal = _interopRequireDefault(require("antd/lib/modal"));

require("antd/lib/modal/style");

var _button = _interopRequireDefault(require("antd/lib/button"));

require("antd/lib/button/style");

var _PcItem = _interopRequireDefault(require("../../../components/PcItem/PcItem"));

var _dec, _class, _temp;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var index = (_dec = (0, _dvaNoRouter.connect)(function (_ref) {
  var global = _ref.global;
  return _objectSpread({}, global);
}), _dec(_class = (_temp =
/*#__PURE__*/
function (_Component) {
  _inherits(index, _Component);

  function index(props) {
    var _this;

    _classCallCheck(this, index);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(index).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleGetModalMainDetail", function () {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          appId = _this$props.appId;
      dispatch({
        type: 'global/fetchModalMainDetail',
        params: {
          appid: appId
        },
        callback: _this.handleDetail
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleDetail", function () {
      var _this$props2 = _this.props,
          pcVersionNum = _this$props2.pcVersionNum,
          appId = _this$props2.appId,
          pcMainTitle = _this$props2.pcMainTitle,
          pcButtonTitle = _this$props2.pcButtonTitle,
          pcBGImg = _this$props2.pcBGImg,
          childList = _this$props2.childList;
      var nowPcAppProps = JSON.parse(localStorage.getItem("".concat(appId, "PcAppProps")) || null);
      var versionChange = !nowPcAppProps || pcVersionNum !== nowPcAppProps && nowPcAppProps.pcVersionNum && appId === nowPcAppProps && nowPcAppProps.appId;
      var mainProps = pcMainTitle && pcButtonTitle && pcVersionNum && pcBGImg;
      var detailProps = false;

      if (!childList || !childList.length) {
        detailProps = false;
      } else {
        childList.forEach(function (item) {
          if (item.tType && item.title && item.orderNum) {
            detailProps = true;
          }
        });
      }

      if (versionChange && mainProps && detailProps) {
        _this.setState({
          isShowModal: true
        });

        var tempAppProps = {
          appId: appId,
          pcVersionNum: pcVersionNum
        };
        localStorage.setItem("".concat(appId, "PcAppProps"), JSON.stringify(tempAppProps));
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleCloseModal", function () {
      _this.setState({
        isShowModal: false
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderModalHeader", function () {
      var _this$props3 = _this.props,
          pcMainTitle = _this$props3.pcMainTitle,
          pcMinTitle = _this$props3.pcMinTitle,
          pcBGImg = _this$props3.pcBGImg;
      return _react.default.createElement("div", {
        className: "nbugs-production-introduction-header",
        style: {
          backgroundImage: "url(".concat(pcBGImg, ")")
        }
      }, _react.default.createElement("span", {
        className: "appNam"
      }, "".concat(pcMainTitle, " - ")), _react.default.createElement("span", {
        className: "appNamIntro"
      }, pcMinTitle));
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderModalBody", function () {
      var childList = _this.props.childList;
      return _react.default.createElement("div", {
        className: "nbugs-production-introduction-body"
      }, childList && childList.map(function (item) {
        return _react.default.createElement(_PcItem.default, {
          detail: item,
          index: item.orderNum
        });
      }));
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderModalFooter", function () {
      var pcButtonTitle = _this.props.pcButtonTitle;
      return _react.default.createElement("div", {
        className: "nbugs-production-introduction-modal-footerWrapper"
      }, _react.default.createElement(_button.default, {
        type: "primary",
        onClick: _this.handleCloseModal
      }, pcButtonTitle));
    });

    _this.state = {
      isShowModal: false
    };
    return _this;
  }

  _createClass(index, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props4 = this.props,
          dispatch = _this$props4.dispatch,
          appId = _this$props4.appId;
      dispatch({
        type: 'global/fetchModalChildDetail',
        params: {
          appid: appId,
          type: 'pc'
        },
        callback: this.handleGetModalMainDetail
      });
    }
  }, {
    key: "render",
    value: function render() {
      var modalWrapperClassName = this.props.modalWrapperClassName;
      var isShowModal = this.state.isShowModal;
      var appCls = (0, _classnames.default)(['nbugs-production-introduction-modal', modalWrapperClassName]);
      var modalProps = {
        wrapClassName: appCls,
        maskClosable: false,
        visible: isShowModal,
        keyboard: false,
        closable: false,
        footer: this.renderModalFooter(),
        title: this.renderModalHeader()
      };
      return _react.default.createElement("div", null, _react.default.createElement(_modal.default, modalProps, this.renderModalBody()));
    }
  }]);

  return index;
}(_react.Component), _temp)) || _class);
var _default = index;
exports.default = _default;